import { Trans } from 'next-i18next'
import styled from 'styled-components'
import { ErrorMessage } from 'formik'

import { colors } from '@/styles'
import { FieldInput, Group } from '@/components/form'
import { ParagraphSmall } from '@/components/text'

const AgreeLabel = styled.label`
  color: ${colors.grey32};
`

const ErrorMessageContainer = styled(ErrorMessage)`
  color: ${colors.pink};
  font-size: 11px;
  padding-left: 6px;
  line-height: 18px;
  margin: 0 0 0 5px;
  width: 100%;
  text-align: left;
`

const TermsContainer = styled(Group)`
  margin: 0;
  gap: 0 8px;
  color: ${colors.grey32};
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;

  > input {
    margin-top: 2px;
  }

  & > p {
    display: none;
  }

  label {
    padding-left: 0;
    margin-right: 10px;
  }
`

const Link = styled.a`
  color: ${colors.link};
  font-weight: 500;
  text-decoration: underline;
`

const Wrapper = styled.div<{ top: number; bottom: number }>`
  margin: ${props => props.top}px 0 ${props => props.bottom}px;
`

type AgreeToTermsProps = {
  implicit?: boolean
  top?: number
  bottom?: number
  t: (key: string) => string
}

const AgreeToTerms: React.FC<AgreeToTermsProps> = ({
  top = 16,
  bottom = 0,
  implicit,
  t
}) => {
  return (
    <Wrapper top={top} bottom={bottom}>
      <TermsContainer col={12} inline>
        {!implicit && (
          <FieldInput
            id="agree_to_terms"
            name="agree_to_terms"
            type="checkbox"
          />
        )}
        <ParagraphSmall>
          {implicit ? (
            <Trans
              i18nKey="b.auth.create.social_login_terms_and_conditions.text"
              t={t}
            >
              By signing in with the services above, you confirm that you are
              over 13 years old and that you have read and agreed to liv.rent
              {`'`}s{' '}
              <Link href="/terms" target="_blank">
                Terms & Conditions
              </Link>{' '}
              and{' '}
              <Link href="/privacy" target="_blank">
                Privacy Policy
              </Link>
              .
            </Trans>
          ) : (
            <Trans
              i18nKey="listing:b.appointment.modal.agree_terms_privacy.text"
              t={t}
            >
              <AgreeLabel htmlFor="agree_to_terms">
                By checking this, I confirm that I am over 13 years old and that
                I have read and agree to liv.rent{`'`}s{' '}
                <Link
                  href="https://liv.rent/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </Link>{' '}
                and{' '}
                <Link
                  href="https://liv.rent/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .
              </AgreeLabel>
            </Trans>
          )}
        </ParagraphSmall>
      </TermsContainer>
      <ErrorMessageContainer component="span" name="agree_to_terms" />
    </Wrapper>
  )
}

export default AgreeToTerms
